import { CurrencySelect } from "@/components/Selector";
import { getTruePrice, numFormmater } from "@/pages/Requirement/util";
import SText from "@/styles/SText";
import { dateFormat } from "@/utils/format";
import { Flex, InputNumber } from "antd";
import type { ColumnType, TableProps } from "antd/es/table";
import dayjs from "dayjs";
import { Dispatch, forwardRef, SetStateAction, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { TableWrap } from "../style";
import { QuotationRequest, Requirement } from "@/types/requirement";
import { useTranslation } from "react-i18next";
import { DictItem } from "@/types/dict";
import { Product } from "@/types/product";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { divided } from "@/utils/calc";
import { DictContext } from "@/layout/context/DictContext";
import CommonTable from "@/components/CommonTable";
import WmsTags from "@/components/WmsTags";
import { ItemLabelEnum, TagLabel } from "@/types/common";
// import { multi } from "@/utils/calc";

interface IProps extends TableProps {
    detailId: string;
    setpurchesePrice: Dispatch<SetStateAction<number>>;
    detail: Requirement | null;
    disabled?: boolean;
    handleEdit?: () => void;
}

interface UpdateQuotationRequest extends QuotationRequest {
    editFlag?: boolean;
}

type ListData = {
    itemId: string;
    product: Product | null;
    quotationRequest: UpdateQuotationRequest,
    equotationRequest: UpdateQuotationRequest | null,
    tags: Array<TagLabel>;
}

export interface FinanceTableRef {
    getSavedRows: () => Array<QuotationRequest>
}

const FinanceTable = forwardRef<FinanceTableRef, IProps>(({ detailId, setpurchesePrice, detail, disabled = true, ...props }, ref) => {

    const { t } = useTranslation();
    const { exchangeRate } = useContext(DictContext);

    const [listData, setListData] = useState<Array<ListData>>([])
    const [sheight, setSheight] = useState<number>(0);
    const tableWrapRef = useRef<HTMLDivElement>(null);

    const isRepTip = useMemo(() => {
        return !!(listData.find(data => !!data?.product?.replacement))
    }, [listData])


    const mainCurrency: DictItem = useMemo(() => {
        if (exchangeRate && exchangeRate.length > 0) {
            for (let i = 0; i < exchangeRate.length; i++) {
                if (exchangeRate[i].desc === "mainCurrency") return exchangeRate[i]
            }
        }
        return {
            id: '2',
            type: 'EXCHANGE_RATE',
            desc: 'mainCurrency',
            key: '2',
            value: 10000
        } as unknown as DictItem;

    }, [exchangeRate]);

    const getRate = (k1: string, k2: string) => {
        const c1 = exchangeRate.find(c => c.key === k1);
        const c2 = exchangeRate.find(c => c.key === k2);
        if (c1?.value && c2?.value) {
            return divided(c1.value, c2.value)
        }
        return '1';
    }

    useEffect(() => {
        if (detail) {
            let arr: Array<ListData> = [];
            detail.items.forEach(item => {
                if (item.quotationRequest) {
                    let tPrice = getTruePrice(item.quotationRequest);
                    let eRate = item.equotationRequest?.exchangeRate || getRate(mainCurrency.key, item.equotationRequest?.supplier?.currency || '')
                    let qRate = item.quotationRequest.exchangeRate || getRate(mainCurrency.key, item.quotationRequest?.supplier?.currency || '')

                    let obj: ListData = {
                        itemId: item.id,
                        quotationRequest: {
                            ...item.quotationRequest,
                            standardPrice: item.quotationRequest.standardPrice || (Number(tPrice ?? 0) * Number(qRate) + '')
                        },
                        equotationRequest: item.equotationRequest ? {
                            ...item.equotationRequest,
                            standardPrice: item.quotationRequest.standardPrice || Number(tPrice ?? 0) * Number(eRate) + ''
                        } : null,
                        product: item.product,
                        tags: item.tags || []
                    }
                    arr.push(obj)
                }
            })
            setListData(arr);
            setTimeout(() => {
                setSheight((tableWrapRef.current?.getBoundingClientRect().height || 400) - 60);

            }, 800)
        }
    }, [detail]);

    const changeCur = (record: ListData, cur: string, type: "Q" | "E") => {
        setListData(last => last.map(item => {
            if ((type === "E" && record.equotationRequest && record.equotationRequest.id === item.equotationRequest?.id) || (type === "Q" && record.quotationRequest.id === item.equotationRequest?.id)) {
                let ETPrice = getTruePrice(item.equotationRequest)
                let QTPrice = getTruePrice(item.quotationRequest)
                let eRate = getRate(cur, record.equotationRequest?.supplier?.currency || '')
                let qRate = getRate(cur, record.quotationRequest?.supplier?.currency || '')
                let obj: ListData = {
                    ...item,
                    equotationRequest: item.equotationRequest ? {
                        ...item.equotationRequest,
                        standardCurrency: type == 'E' ? cur : item.equotationRequest.standardCurrency,
                        exchangeRate: type === 'E' ? eRate : item.equotationRequest.exchangeRate,
                        standardPrice: type === 'E' ? Number(eRate) * (ETPrice || 0) + '' : item.equotationRequest.standardCurrency,
                        editFlag: true,
                    } : null,
                    quotationRequest: {
                        ...item.quotationRequest,
                        standardCurrency: type == 'Q' ? cur : item.quotationRequest.standardCurrency,
                        exchangeRate: type === 'Q' ? qRate : item.quotationRequest.exchangeRate,
                        standardPrice: type === 'Q' ? Number(qRate) * (QTPrice || 0) + '' : item.quotationRequest.standardPrice,
                        editFlag: true,
                    }
                }
                return { ...obj }
            } else return { ...item }
        }))
    }

    const changeRate = (record: ListData, val: number, type: "Q" | "E") => {
        setListData(last => last.map(item => {
            if ((type === "E" && record.equotationRequest && record.equotationRequest.id === item.equotationRequest?.id) || (type === "Q" && record.quotationRequest.id === item.equotationRequest?.id)) {
                let QTPrice = getTruePrice(item.quotationRequest)
                let ETPrice = getTruePrice(item.equotationRequest)
                let obj: ListData = {
                    ...item,
                    equotationRequest: item.equotationRequest ? {
                        ...item.equotationRequest,
                        exchangeRate: type === "E" ? val + '' : item.equotationRequest.exchangeRate,
                        standardPrice: type === "E" ? (ETPrice || 0) * val + '' : item.equotationRequest.standardPrice,
                        editFlag: true,
                    } : null,
                    quotationRequest: {
                        ...item.quotationRequest,
                        exchangeRate: type === "Q" ? val + '' : item.quotationRequest.exchangeRate,
                        standardPrice: type === "Q" ? (QTPrice || 0) * val + '' : item.quotationRequest.standardPrice,
                        editFlag: true,
                    }
                }
                return { ...obj }
            } else return { ...item }
        }))

    }

    const columns = useMemo<ColumnType<ListData>[]>(() => [
        {
            title: <SText text={t("purchase.name")} />,
            dataIndex: ["quotationRequest", 'supplier', 'name'],
            key: 'supplierName',
            width: 120,
            render: (val, record, idex) => <SText text={record?.quotationRequest?.supplier?.name || ''} style={{ width: 120 }} />
        },
        {
            title: <SText text={t("purchase.code")} />,
            dataIndex: ["quotationRequest", 'supplier', 'code'],
            key: 'supplierCode',
            width: 120,
            render: (val, record, idex) => <SText text={record?.quotationRequest?.supplier?.code || ''} />
        },
        {
            title: <SText text={t("purchase.materialCode")} />,
            dataIndex: ['product', 'code'],
            key: 'productCode',
            width: 120,
            render: (val, record, idex) => <SText style={{ color: !!record?.product?.replacement ? "orange" : undefined }} text={record?.product?.code || ''} />

        },
        {
            title: <SText text={t("purchase.materialName")} />,
            dataIndex: ['product', 'name'],
            key: 'productName',
            width: 140,
            render: (val, record, idex) => <SText text={record?.product?.name || ''} style={{ width: 140 }} />
        },
        {
            title: <SText text={t("product.brand1")} />,
            dataIndex: ['product', 'model'],
            key: 'productModel',
            width: 160,
            render: (val, record, idex) => <SText text={record?.product?.model || ''} style={{ width: 160 }} />
        },
        {
            title: <SText text={t("purchase.purCount")} />,
            dataIndex: ["quotationRequest", 'count'],
            key: 'count',
            width: 100,
            render: (_, record) => (
                <SText text={numFormmater(Number(record?.quotationRequest.count) || 0)} style={{ width: 100 }} />
            )
        },
        {
            title: <SText text={t("purchase.supplierTime")} />,
            key: 'supplierTime',
            width: 160,
            render: (_, record) => {
                if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id) return <Flex vertical gap={2}>
                    <SText text={dateFormat(dayjs(Number(record?.quotationRequest?.supplierTime)), false)} />
                    <SText text={dateFormat(dayjs(Number(record?.equotationRequest?.supplierTime)), false)} />
                </Flex>
                else return <SText text={dateFormat(dayjs(Number(record?.quotationRequest?.supplierTime)), false)} />
            },
        },
        {
            title: <SText text={t("purchase.mpq")} />,
            dataIndex: ["quotationRequest", 'mpq'],
            key: 'mpq',
            width: 120,
            render: (_, record) => {
                if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id) return <Flex vertical gap={2}>
                    <SText text={record?.quotationRequest?.mpq || ''} />
                    <SText text={record?.equotationRequest?.mpq || ''} />
                </Flex>
                else return <SText text={record?.quotationRequest?.mpq || ''} />
            },
        },
        {
            title: <SText text={t("purchase.days")} />,
            dataIndex: ["quotationRequest", 'days'],
            key: 'days',
            width: 120,
            render: (_, record) => {
                if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id) return <Flex vertical gap={2}>
                    <SText text={record?.quotationRequest?.days ? record.quotationRequest.days + '' : ''} />
                    <SText text={record?.equotationRequest?.days ? record.equotationRequest.days + '' : ''} />
                </Flex>
                else return <SText text={record?.quotationRequest?.days ? record.quotationRequest.days + '' : ''} />
            },
        },
        {
            title: <SText text={t("warehouse.labels")} />,
            dataIndex: "tags",
            key: 'tags',
            width: 120,
            render: (_, record) => {
                return <WmsTags refId={record.itemId} refType={ItemLabelEnum.REQUIREMENT_ITEM} tags={record.tags || []} />
            },
        },
        {
            title: <SText text={t("purchase.purCurrency")} />,
            dataIndex: ["supplier", "currency"],
            key: 'supplierCurrency',
            fixed: "right",
            width: 100,
            render: (_, record) => <CurrencySelect readOnly value={record.quotationRequest?.supplier?.currency} />
        },
        {
            title: <SText text={t("purchase.purPrice_1")} />,
            dataIndex: 'price',
            key: 'totalPrice',
            fixed: "right",
            width: 100,
            render: (_, record) => {
                if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id) return (
                    <Flex vertical gap={2}>
                        <SText text={numFormmater(getTruePrice(record.equotationRequest) || 0)} style={{ width: 100 }} />
                        <SText text={numFormmater(getTruePrice(record.quotationRequest) || 0)} style={{ width: 100 }} />
                    </Flex>
                )
                else return (
                    <SText text={numFormmater(getTruePrice(record.quotationRequest) || 0)} style={{ width: 100 }} />
                )
            },
        },
        {
            title: <SText text={t("purchase.purPrice_2")} />,
            dataIndex: 'price',
            key: 'supplierPrice',
            fixed: "right",
            width: 100,
            render: (_, record) => {
                if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id) return (
                    <Flex vertical gap={2}>
                        <SText text={numFormmater(Number(record.equotationRequest?.supplierPrice || '') || 0)} style={{ width: 100 }} />
                        <SText text={numFormmater(Number(record.quotationRequest.supplierPrice || '') || 0)} style={{ width: 100 }} />
                    </Flex>
                )
                else return (
                    <SText text={numFormmater(Number(record.quotationRequest.supplierPrice || '') || 0)} style={{ width: 100 }} />
                )
            },
        },
        {
            title: <SText text={t("purchase.curr")} />,
            key: "supplierCurrencyCopy",
            fixed: "right",
            width: 120,
            render: (value, record) => {
                if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id) return (
                    <Flex vertical gap={2}>
                        <CurrencySelect value={(record.quotationRequest.standardCurrency + '' || mainCurrency.key) + ''} readOnly />
                        <CurrencySelect value={(record.equotationRequest.standardCurrency + '' || mainCurrency.key) + ''} onChange={cur => {
                            changeCur(record, cur, "E");
                        }} />
                    </Flex>
                )
                else return (
                    <CurrencySelect value={(record?.quotationRequest?.standardCurrency || mainCurrency.key) + ''}
                        onChange={cur => changeCur(record, cur, "Q")}
                    />
                )
            }
        },
        {
            title: <SText text={t("purchase.exchangeRateL")} />,
            key: "supplierCurrencyRate",
            fixed: "right",
            width: 140,
            render: (value, record) => {
                if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id) return (
                    <Flex vertical gap={2}>
                        <InputNumber changeOnWheel formatter={val => numFormmater(Number(val) || 0)}
                            value={record.quotationRequest.exchangeRate || getRate(mainCurrency.key, record.quotationRequest?.supplier?.currency || '')}
                            readOnly />
                        <InputNumber changeOnWheel formatter={val => numFormmater(Number(val) || 0)}
                            value={record.equotationRequest.exchangeRate || getRate(mainCurrency.key, record.equotationRequest?.supplier?.currency || '')}
                            min={'0'} onChange={val => changeRate(record, Number(val) || 1, 'E')}
                        />
                    </Flex>
                )
                else return (
                    <InputNumber changeOnWheel formatter={val => numFormmater(Number(val) || 0)}
                        value={record?.quotationRequest.exchangeRate || getRate(mainCurrency.key, record.quotationRequest?.supplier?.currency || '')}
                        min={'0'} onChange={val => changeRate(record, Number(val) || 1, 'Q')}
                    />
                )
            },
        },
        {
            title: <SText text={t("purchase.purPrice")} />,
            dataIndex: 'price',
            key: 'standardPrice',
            fixed: "right",
            width: 100,
            render: (_, record) => {
                if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id) return (
                    <Flex vertical gap={2}>
                        <SText text={numFormmater(Number(record.quotationRequest.standardPrice))} style={{ width: 100 }} />
                        <SText text={numFormmater(Number(record.equotationRequest?.standardPrice ?? ''))} style={{ width: 100 }} />
                    </Flex>
                )
                else return (
                    <SText text={numFormmater(Number(record.quotationRequest.standardPrice))} style={{ width: 100 }} />
                )
            },
        },
        {
            title: <SText text={t('purchase.equotationRequest')} />,
            key: "equotationRequest",
            width: 120,
            fixed: "right",
            render(_, record) {
                if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id) return (
                    <Flex vertical gap={2}>
                        <CloseOutlined style={{ color: '#f50' }} />
                        <CheckOutlined style={{ color: '#87d068' }} />
                    </Flex>
                )
                else if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id === record.quotationRequest.id) return (
                    <CheckOutlined style={{ color: '#87d068' }} />
                )
                else if (!record.equotationRequest && record.quotationRequest) return <CloseOutlined style={{ color: '#f50' }} />
                else return null
            }
        }
    ], [exchangeRate]);

    const totalStandered = useMemo(() => {
        let sum = 0;
        listData.forEach(record => {
            if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id) {
                sum = sum + Number(record.equotationRequest.standardPrice ?? 0)
            }
            else {
                sum = sum + Number(record.quotationRequest.standardPrice ?? 0)
            }
        })
        setpurchesePrice(sum)
        return numFormmater(sum);
    }, [listData])

    useImperativeHandle(ref, () => ({
        getSavedRows: () => {
            let resArr: QuotationRequest[] = [];
            listData.forEach(record => {
                if (record.quotationRequest && record.equotationRequest && record.equotationRequest.id !== record.quotationRequest.id && record.equotationRequest.editFlag) {
                    resArr.push(record.equotationRequest)
                } else if (record?.quotationRequest?.editFlag) {
                    resArr.push(record.quotationRequest)
                }
            })
            return resArr;
        }
    }));

    return <TableWrap ref={tableWrapRef}>
        {isRepTip && <div style={{ color: "orange" }}>{t('requirement.duplicateMaterialTip')}</div>}
        <CommonTable
            rowKey="itemId"
            columns={columns}
            dataSource={listData}
            scrollHeight={sheight}
        />
        <div className="total-row" >{t('purchase.all') + ': ' + totalStandered}</div>
    </TableWrap>


})

export default FinanceTable;